import { Address, RecipientType } from '@this+that/models';
import { formatSenderAddress } from '@this+that/utils';

type AddressesByType = {
  to: string[];
  cc: string[];
  bcc: string[];
  [key: string]: string[];
};

export type AddressesByRecipientType = {
  to: Address[];
  cc: Address[];
  bcc: Address[];
};

export const tagAddressesWithTypes = ({
  to,
  cc,
  bcc,
}: AddressesByRecipientType): Address[] => {
  const tagAddress = (address: Address, type: RecipientType): Address => ({
    value: address.value,
    label: address.label,
    type,
  });

  return [
    ...to.map((address) => tagAddress(address, RecipientType.TO)),
    ...cc.map((address) => tagAddress(address, RecipientType.CC)),
    ...bcc.map((address) => tagAddress(address, RecipientType.BCC)),
  ];
};

export const getAddressesByType = (recipients: Address[]): AddressesByType => {
  return recipients.reduce<AddressesByType>(
    (acc, recipient) => {
      if (!acc[recipient.type!]) {
        acc[recipient.type!] = [];
      }
      acc[recipient.type!].push(
        recipient.label?.trim() === recipient.value
          ? recipient.value
          : formatSenderAddress(recipient.label, recipient.value),
      );
      return acc;
    },
    { to: [], cc: [], bcc: [] },
  );
};

export const emptyToUndefined = (arr: string[]): string[] | undefined =>
  arr.length > 0 ? arr : undefined;
